export const config = {
  title: "Salza Construction LLC | Roofing & Remodeling in Dale, TX",
  meta: {
    description:
      "Salza Construction LLC specializes in expert roofing, remodeling, and construction solutions across Dale, TX and surrounding communities. Quality work, honest service.",
    keywords: [
      "Salza Construction LLC",
      "Roofing Dale TX",
      "Remodeling Dale TX",
      "Construction Dale TX",
      "Texas roofing contractors",
      "Home remodeling in Dale TX"
    ],
    author: "Salza Construction LLC",
    canonicalUrl: "https://salzaconstructionllc.com/",
  },
  sections: {
    header: {
      businessName: "Salza Construction LLC",
    },
    sectionB: {
      heroTitle: "Salza Construction LLC",
      heroSubtitle: "Roofing & Remodeling Experts in Dale, TX",
      learnAboutText: "Get a Free Estimate",
      phoneNumber: "2108378630",
      phoneLabel: "(210) 837-8630",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1475286239/photo/workers-at-a-construction-site-weld-metal-structures-of-precast-concrete-slabs.jpg?s=612x612&w=0&k=20&c=GB-rZnJbRMEv9emnaPD2YXdnQuHE3zL-kr93yZRJPWg=",
      cardData: [
        {
          title: "Roofing Services",
          description: "Professional roof repair, replacement, and installation.",
        },
        {
          title: "Remodeling",
          description: "Interior and exterior remodeling tailored to your needs.",
        },
        {
          title: "Construction",
          description: "Residential construction with craftsmanship and care.",
        },
      ],
      description:
        "Salza Construction LLC is your trusted local contractor in Dale, TX, delivering high-quality roofing and remodeling solutions with integrity and excellence.",
    },
    sectionC: {
      servicesTitle: "What We Do",
      servicesDescription:
        "From roofing and siding to full remodels and new construction, we bring your home improvement vision to life.",
      cards: [
        {
          title: "Roof Replacement",
          description: "Durable roofing systems designed to protect your home.",
          imageSrc: "https://media.istockphoto.com/id/1459217836/photo/new-roof-on-saltbox-colonial-house.jpg?s=612x612&w=0&k=20&c=62Co1I-HPvCj4YkE5cfPOMZbfpcSEqSSYg4n_mOPXnE=",
          imageAlt: "Roofing Service",
        },
        {
          title: "Siding Installation",
          description: "Boost curb appeal with expert siding services.",
          imageSrc: "https://media.istockphoto.com/id/2197662613/photo/construction-worker-repairing-a-house-siding.jpg?s=612x612&w=0&k=20&c=P86mkBhIgK7j1vDaszoMqJAKMoyzExh3__8gCowFup8=",
          imageAlt: "Siding Service",
        },
        {
          title: "Full Remodeling",
          description: "Transform your space with our skilled remodeling team.",
          imageSrc: "https://media.istockphoto.com/id/1369365750/photo/home-roof-replacement.jpg?s=612x612&w=0&k=20&c=AmAZZBDyEtWbkyBrOksYnbaf__jDpPIsz_7_ObyaroM=",
          imageAlt: "Remodeling Project",
        },
      ],
      otherServicesTitle: "Why Choose Us",
      otherServicesList: [
        "Family-Owned & Operated",
        "Honest & Transparent Pricing",
        "Licensed & Insured",
        "Top-Quality Materials",
        "Free Inspections & Estimates",
      ],
    },
    sectionD: {
      aboutTitle: "About Salza Construction LLC",
      aboutImage: {
        src: "https://media.istockphoto.com/id/1042342584/photo/investors-and-contractors-on-construction-site.jpg?s=612x612&w=0&k=20&c=dfpqU0nr9BccCHOdHNyI1UanHGLt1nD2t6jZp95YUe4=",
        alt: "Salza Construction LLC Logo",
      },
      aboutText: [
        "Based in Dale, TX, Salza Construction LLC is dedicated to providing exceptional residential roofing and construction services throughout the region.",
        "We’re a locally-owned business that believes in honesty, hard work, and delivering results you can rely on."
      ],
    },
    sectionE: {
      profileImage: "https://firebasestorage.googleapis.com/v0/b/interscopemediacrm.appspot.com/o/Clientes%2F475b799c-c6eb-447b-b2b2-9c2c8fba2f40%2F475b799c-c6eb-447b-b2b2-9c2c8fba2f40_whiteLogo.webp?alt=media&token=91609f28-53df-4ff7-ba64-fafee668fc6b",
      profileAlt: "Salza Construction LLC Logo",
      businessName: "Salza Construction LLC",
      contact: {
        phone: "2108378630",
        phoneLabel: "(210) 837-8630",
        email: "ig303511@gmail.com",
        website: "https://salzaconstructionllc.com/",
        address: "Dale, TX, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Dale, TX, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d347232.6936463348!2d-97.82260267084798!3d29.96940341236485!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8644b97a2032f6b5%3A0x7460042b1619b176!2sDale%2C%20TX%2078652%2C%20USA!5e0!3m2!1sen!2sph!4v1694871998762!5m2!1sen!2sph"
    },    
  },
};

export default config;
